/**
 * Standalone, Keycloak-free guest app bootstrap.
 *
 * Runs in main.tsx BEFORE — and INSTEAD OF — the normal app bootstrap when the current path is
 * `/p` (the guest access link). Same pattern as signup-standalone/verify-standalone: the path check
 * happens before `initKeycloak()` so the guest, who has no Keycloak session, never hits the
 * `login-required` redirect (ADR-001 Amendment 1 — the deliberate pre-router short-circuit).
 *
 * Does NOT use TanStack Router — mounted as a standalone React root, same as the other public
 * pages.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { GuestApp } from './GuestApp';

export const GUEST_PATH = '/p';

export function runGuestApp(): void {
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root, {
    onCaughtError: Sentry.reactErrorHandler(),
    onUncaughtError: Sentry.reactErrorHandler(),
  }).render(
    <StrictMode>
      <GuestApp />
    </StrictMode>,
  );
}
